import styled, { css } from 'styled-components';
import { FontFamilyBold, FontFamilyRegular, FontFamilyMedium } from './fonts';
import { THEME_COLORS, BREAKPOINTS } from '../styles/theme';

export const baseStyle = css`
    margin: 0;
`;

/**
 * Style for the main title of the page
 */
export const TitleMainStyle = css`
    font-size: 42px;
    font-weight: normal;
    ${baseStyle};
    color: ${props => props.theme.color[THEME_COLORS.darkBlue]};
    ${FontFamilyBold};
    @media (max-width: ${BREAKPOINTS.sm}) {
        font-size: 28px;
    }
`;

/**
 * Style for every other less important title
 */
export const TitleStyle = css`
    font-size: 22px;
    font-weight: 500;
    ${FontFamilyMedium};
    ${baseStyle};
    color: ${props => props.theme.color[THEME_COLORS.darkBlue]};
`;

/**
 * Style for a subtitle
 */
export const SubtitleStyle = css`
    font-size: 18px;
    font-weight: normal;
    ${baseStyle};
    color: ${props => props.theme.color[THEME_COLORS.darkBlue]};
    ${FontFamilyRegular};
`;

/**
 * Default h1 with main title style
 */
export const TitleMain = styled.h1`
    ${TitleMainStyle}
`;

/**
 * Default h2 with title style
 */
export const Title = styled.h2`
    ${TitleStyle}
`;

/**
 * Default h3 with subtitle style
 */
export const Subtitle = styled.h3`
    ${SubtitleStyle}
`;

export const Paragraph = styled.p`
    margin: 0;
    font-size: 16px;
    ${props => props.medium ? FontFamilyMedium : FontFamilyRegular};
    line-height: 22px;
`;